import _decorate from "@babel/runtime/helpers/esm/decorate";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "@babel/runtime/helpers/esm/get";
let _ = t => t,
  _t;
function _superPropGet(t, e, r, o) { var p = _get(_getPrototypeOf(1 & o ? t.prototype : t), e, r); return 2 & o ? function (t) { return p.apply(r, t); } : p; }
/**
 * @license
 *
 * Copyright IBM Corp. 2021, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { css } from 'lit';
import settings from '@carbon/ibmdotcom-utilities/es/utilities/settings/settings.js';
import C4DImage from "../image/image.js";
import styles from "././card-in-card.css.js";
import { carbonElement as customElement } from '@carbon/web-components/es/globals/decorators/carbon-element.js';
const {
  stablePrefix: c4dPrefix
} = settings;

/**
 * Card in Card Extends Image.
 *
 * @element c4d-card-in-card-image
 */
let C4DCardInCardImage = _decorate([customElement(`${c4dPrefix}-card-in-card-image`)], function (_initialize, _C4DImage) {
  class C4DCardInCardImage extends _C4DImage {
    constructor(...args) {
      super(...args);
      _initialize(this);
    }
  }
  return {
    F: C4DCardInCardImage,
    d: [{
      kind: "get",
      static: true,
      key: "styles",
      value:
      // `styles` here is a `CSSResult` generated by custom WebPack loader
      function () {
        return css(_t || (_t = _`
      ${0}${0}
    `), _superPropGet(C4DCardInCardImage, "styles", this), styles);
      }
    }]
  };
}, C4DImage);
/* @__GENERATE_REACT_CUSTOM_ELEMENT_TYPE__ */
export default C4DCardInCardImage;
//# sourceMappingURL=card-in-card-image.js.map
